module.exports = __webpack_public_path__ + "static/img/a090.254bfcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a090.jpg
// module id = H8pS
// module chunks = 0